import React from 'react';
import { DataGrid, GridColDef, GridRowSelectionModel } from '@mui/x-data-grid';
import { Box, Typography } from '@mui/material';
import { getFeeDetailsColumns } from '../utils/feeDetailsTableColumns';
import { StudentPaymentSchemeWithMetrics } from '../../../types/paymentScheme';
import { dataGridSx } from '../../common/styled/DataGrid';
import pallet from '../../../layouts/pallet';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';
import tableColumnUtils from '../../../utils/tableColumnUtils';
import CustomDataGridToolbar from '../../common/components/CustomDataGridToolbar';

interface FeeDetailsTableProps {
  title: string;
  feeDetails: StudentPaymentSchemeWithMetrics[];
  isLoading: boolean;
  checkboxSelection?: boolean;
  rowSelectionModel?: GridRowSelectionModel;
  onRowSelectionModelChange?: (selectionModel: GridRowSelectionModel) => void;
  onApproveRejectClick: (scheme: StudentPaymentSchemeWithMetrics) => void;
  onUpdateFeeStatusClick: (scheme: StudentPaymentSchemeWithMetrics) => void;
  hideCustomColumns?: boolean;
}

const FeeDetailsTable: React.FC<FeeDetailsTableProps> = ({
  title,
  feeDetails,
  isLoading,
  checkboxSelection = false,
  rowSelectionModel,
  onRowSelectionModelChange,
  onApproveRejectClick,
  onUpdateFeeStatusClick,
  hideCustomColumns = false
}) => {
  const { paymentUser } = useSelector((state: RootState) => state.paymentUser);

  const columns: GridColDef[] = getFeeDetailsColumns(
    feeDetails,
    onApproveRejectClick,
    onUpdateFeeStatusClick,
    hideCustomColumns,
    paymentUser
  );

  return (
    <Box mb='24px'>
      <Typography fontSize='18px !important' fontWeight={700} mb='16px'>
        {title}
      </Typography>
      <Box sx={{ width: '100%' }}>
        <DataGrid
          rows={feeDetails}
          columns={columns}
          loading={isLoading}
          checkboxSelection={checkboxSelection}
          rowSelectionModel={rowSelectionModel}
          onRowSelectionModelChange={onRowSelectionModelChange}
          getRowId={(row) => row._id}
          disableColumnMenu
          pageSizeOptions={tableColumnUtils.PAGE_SIZE_OPTIONS}
          initialState={tableColumnUtils.DATA_GRID_INITIAL_STATE}
          showToolbar
          slots={{ toolbar: CustomDataGridToolbar }}
          slotProps={{
            toolbar: {
              printOptions: { disableToolbarButton: true },
              showQuickFilter: true
            }
          }}
          sx={{
            ...dataGridSx(pallet),

            '& .MuiDataGrid-virtualScroller': {
              overflowY: 'auto'
            }
          }}
        />
      </Box>
    </Box>
  );
};

export default FeeDetailsTable;
